import { cn } from "@/lib/utils";

interface FeatureImagePlaceholderProps {
  className?: string;
}

/**
 * Fallback beeldkader voor featureblokken en hero's zonder productafbeelding.
 * Vult de volledige gereserveerde ruimte: #F3EDFD, rounded-2xl, met het
 * Learned-beeldmerk gecentreerd op 20% opacity. Geen tekst.
 */
export function FeatureImagePlaceholder({ className }: FeatureImagePlaceholderProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "w-full h-full rounded-2xl flex items-center justify-center overflow-hidden",
        className,
      )}
      style={{ backgroundColor: "#F3EDFD" }}
    >
      <img src="/favicon.svg" alt="" className="w-24 h-24 opacity-20" loading="lazy" />
    </div>
  );
}
